import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDIhGMdDYmG6UZT99_PF5zOQGc5MOO0BAo",
  authDomain: "flylab-674a2.firebaseapp.com",
  databaseURL: "https://flylab-674a2-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "flylab-674a2",
  storageBucket: "flylab-674a2.appspot.com",
  messagingSenderId: "95338918486",
  appId: "1:95338918486:web:46d4f088fd72fc65f981f7",
  measurementId: "G-36X1J18GJ1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);

export default app;